export default __webpack_public_path__ + "static/media/etehadie.a4c19a39.png";